export const APP_STEPS = {
    WELCOME: 'WELCOME',
    GAME: 'GAME',
    FORM: 'FORM',
    SEGMENTATION: 'SEGMENTATION',
    LEADERBOARD: 'LEADERBOARD',
    RESULT_WIN: 'RESULT_WIN',
    RESULT_LOSE: 'RESULT_LOSE',
    MISSED: 'MISSED',
    NO_CONTEST: 'NO_CONTEST',
    QUIZ: 'QUIZ',
    HT_BETTING: 'HT_BETTING',
};